import createVueComponent from '../createVueComponent';
var Martini = createVueComponent('MartiniIcon', [['path', {
  d: 'M8 22h8',
  key: 'rmew8v'
}], ['path', {
  d: 'M12 11v11',
  key: 'ur9y6a'
}], ['path', {
  d: 'm19 3-7 8-7-8Z',
  key: '1sgpiw'
}]]);
export default Martini;